import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Alert from '../Base/Alert'
import { Autocomplete, TextField } from '../Base/Form'
import { getData } from '../../../js/helpers/apiHelper'

const CheckIn = ({ dictionary, endpointCountries, endpointCheckIn }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const [loading, setLoading] = useState(false)
  const [errorMessages, setErrorMessages] = useState()
  const [countries, setCountries] = useState([])

  useEffect(() => {
    getData(endpointCountries).then((response) => setCountries(response?.data))
  }, [])

  const onSubmit = async (data) => {
    try {
      setErrorMessages(null)
      setLoading(true)
      // console.log('payload', data)
      const response = await postData(endpointCheckIn, data)
      if (response.success) {
        //redirect
      } else {
        //show errors
      }
    } catch {
      //show general error msg
      setErrorMessages(['Wrong reference number'])
    } finally {
      setLoading(false)
    }
  }
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="s-modify-search__form s-modify-search__form--tabbed">
      <Autocomplete
        name="country"
        label={dictionary.countryLabel}
        control={control}
        options={countries}
        error={errors.country}
        onInputChange={() => {}}
      />
      <button
        type="button"
        className="btn btn-primary"
        disabled={loading}
        title={dictionary.checkInBtn}>
        {dictionary.checkInBtn}
      </button>
    </form>
  )
}

export default CheckIn
